export default __webpack_public_path__ + "ubisoft-playtest-contact-banner-mobile.webp";